import type { Deal } from "~/models/Deal";
import { getDealStatusBackReasons } from "~/models/DealStatusReason";
import Styles from "./StatusReasonCard.module.scss";

type Props = {
	deal: Deal;
};

export function StatusReasonCard({ deal }: Props) {
	const dealStatusReasons = getDealStatusBackReasons(deal);
	const isEmpty = dealStatusReasons.length === 0;

	return (
		<>
			{!isEmpty && (
				<div className={Styles.StatusCard}>
					<h1 className={Styles.BackReasonTitle}>ステータスが戻されました</h1>
					<h2 className={Styles.CancelReasonLabel}>理由</h2>
					{dealStatusReasons.map((s) => (
						<div key={s.id}>
							<p className={Styles.BackReason}>{s.reason}</p>
						</div>
					))}
				</div>
			)}
		</>
	);
}
